import { useParams } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { useAccount } from "wagmi";
import { useEffect, useState } from "react";
import {
  type Escrow,
  getEscrowByAddress,
} from "../../repository/EscrowRepository.ts";
import EscrowPage from "./EscrowPage.tsx";
import { getAddress } from "viem";

type Role = "SELLER" | "BUYER" | "VIEWER";

const getRole = (escrow: Escrow, address: string): Role => {
  if (escrow.buyer_account.toLowerCase() === address.toLowerCase()) {
    return "BUYER";
  }
  if (escrow.seller_account.toLowerCase() === address.toLowerCase()) {
    return "SELLER";
  }
  return "VIEWER";
};

const EscrowWrapper = () => {
  const { address } = useParams();
  const { address: userAddress } = useAccount();

  const { data: escrow } = useQuery({
    queryKey: ["escrow", address],
    queryFn: async () => getEscrowByAddress(address as string),
    refetchInterval: 2000,
  });

  const [role, setRole] = useState<Role>("VIEWER");

  useEffect(() => {
    if (!address) return;
    if (!escrow) return;
    if (!userAddress) return;
    setRole(getRole(escrow, userAddress));
  }, [userAddress, address, escrow, role]);

  if (!address) {
    return null;
  }

  if (!escrow) {
    return null;
  }

  if (!userAddress) {
    return null;
  }

  return (
    <EscrowPage
      escrow={escrow}
      address={getAddress(escrow.escrow_address)}
      role={role}
      userAddress={getAddress(userAddress)}
    />
  );
};

export default EscrowWrapper;
